import { useEffect } from 'react';
import { useConfig } from '@/contexts/ConfigContext';
import { StandaloneAppConfig } from '@/StandaloneAppConfig';

interface AntimatterStandaloneEnvironment {
  config: StandaloneAppConfig;
}

interface AntimatterClientEnvironment {
  config: unknown;
  flags?: unknown;
}

declare global {
  interface Window {
    getAntimatterStandaloneEnvironment?: () => AntimatterStandaloneEnvironment;
    getAntimatterClientEnvironment?: () => AntimatterClientEnvironment;
  }
}

export function useSyncEnvironmentToWindow() {
  const config = useConfig();

  useEffect(() => {
    window.getAntimatterStandaloneEnvironment = () => {
      return {
        config,
        version: import.meta.env.VITE_VERSION,
      };
    };

    return () => {
      delete window.getAntimatterStandaloneEnvironment;
    };
  }, [config]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== config.IFRAME_URL) {
        return;
      }

      if (event?.data?.source !== 'antimatter-client') {
        return;
      }

      if (event?.data?.windowConfig) {
        window.getAntimatterClientEnvironment = () => {
          return event.data.windowConfig;
        };
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);

      if (window.getAntimatterClientEnvironment) {
        delete window.getAntimatterClientEnvironment;
      }
    };
  }, [config.IFRAME_URL]);
}
